import { QBox, QFlex, QText } from '@qualio/ui-components';
import React from 'react';

type Props = {
  title: string;
  children: React.ReactNode;
  dataCySuffix?: string;
  action?: React.ReactNode;
};

export const PropertySection = ({ title, children, dataCySuffix, action }: Props) => {
  const dataCy = 'properties-' + title.toLowerCase().replace(/ /g, '-') + (dataCySuffix ? `-${dataCySuffix}` : '');
  return (
    <QBox marginBottom={4}>
      <QFlex justifyContent="space-between" alignItems="flex-start">
        <QBox>
          <QText fontSize="sm" fontWeight={600} data-cy={dataCy}>
            {title}
          </QText>
          <div data-cy={`${dataCy}-value`}>{children}</div>
        </QBox>
        {action}
      </QFlex>
    </QBox>
  );
};
